import { Component, computed, input, signal } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { KorviuCheckboxComponent } from 'shared/components/korviu-checkbox/korviu-checkbox.component';
import { KorviuInputComponent } from 'shared/components/korviu-input/korviu-input.component';
import {
  getTaxDocumentFormNameKey,
  getTaxDocumentResidencySuffixKey,
  TAX_DOCUMENT_ORIGINAL_FORM_URLS
} from '../tax-documentation-contract.helpers';

@Component({
  selector: 'app-tax-documentation-w9-certification-step',
  imports: [TranslatePipe, KorviuCheckboxComponent, KorviuInputComponent],
  templateUrl: './tax-documentation-w9-certification-step.component.html',
  styleUrl: '../tax-documentation-modal.component.scss'
})
export class TaxDocumentationW9CertificationStepComponent {
  readonly originalFormUrl = TAX_DOCUMENT_ORIGINAL_FORM_URLS.W9;
  readonly formNameKey = getTaxDocumentFormNameKey('W9');
  readonly residencySuffixKey = getTaxDocumentResidencySuffixKey('W9');

  form = input.required<FormGroup>();
  today = input.required<string>();
  isFullCertificationVisible = signal(false);

  iCertifyControl = computed(() => this.getControl('iCertify'));
  signerNameControl = computed(() => this.getControl('signerName'));

  showFullCertification(): void {
    this.isFullCertificationVisible.set(true);
  }

  private getControl(controlName: string): AbstractControl {
    return this.form().get(controlName);
  }
}
